import { ar, arDZ, arEG, arMA, arSA, arTN, enAU, enCA, enGB, enIE, enIN, enNZ, enUS, enZA } from 'date-fns/locale';

// Maps the user's formatting locale onto its date-fns locale object, so
// `format()` renders dates the way that region writes them (and localized
// month/day names) instead of always falling back to date-fns' US English.
// Keyed by the regional variants date-fns ships for the app's translation
// languages (config/localization.php: en, ar); anything else falls back to the
// base language below.
const DATE_FNS_LOCALES = {
    en: enUS,
    en_AU: enAU,
    en_CA: enCA,
    en_GB: enGB,
    en_IE: enIE,
    en_IN: enIN,
    en_NZ: enNZ,
    en_US: enUS,
    en_ZA: enZA,
    ar,
    ar_DZ: arDZ,
    ar_EG: arEG,
    ar_MA: arMA,
    ar_SA: arSA,
    ar_TN: arTN,
};

/* The region-carrying locale published by the layout. CURRENT_LOCALE is
   collapsed to the translation language ('en'/'ar'), so it can never tell an
   en_AU user from an en_US one. The CURRENT_LOCALE fallback below only fires
   for resources/views/internal_errors/layout.blade.php, the one layout that
   doesn't publish CURRENT_FORMATTING_LOCALE. */
const getFormattingLocale = () => {
    if (typeof window.CURRENT_FORMATTING_LOCALE === 'string' && window.CURRENT_FORMATTING_LOCALE !== '') {
        return window.CURRENT_FORMATTING_LOCALE;
    }

    return typeof window.CURRENT_LOCALE === 'string' ? window.CURRENT_LOCALE : undefined;
};

export const getDateFnsLocale = () => {
    const locale = getFormattingLocale();

    if (typeof locale !== 'string') {
        return undefined;
    }

    // A locale date-fns has no regional variant for (e.g. 'ar_AU') still
    // formats in the right language.
    return DATE_FNS_LOCALES[locale] || DATE_FNS_LOCALES[locale.split('_')[0]];
};

// BCP-47 tag for native Intl calls (toLocaleDateString, Intl.DateTimeFormat),
// e.g. 'en_AU' -> 'en-AU'.
export const getIntlLocale = () => {
    const locale = getFormattingLocale();

    return typeof locale === 'string' ? locale.replace('_', '-') : undefined;
};

export const getDataTableLocaleUrl = () => {
    if (typeof window.CURRENT_LOCALE !== 'string') {
        return;
    }

    if (window.CURRENT_LOCALE.includes('ar')) {
        return {
            url: '/datatable/locale/ar.json',
        };
    }
};

/* The calendars this feeds are the vendored FullCalendar v4 loaded by script
   tag (public/fullcalendar/), whose locales-all.js ships every locale and is
   included alongside it in each hosting view, so no code needs registering
   here. Its lookup walks the code down one dash at a time ('ar-au' -> 'ar')
   and falls back to English for a code it holds nothing for. Regional codes
   matter here beyond month names: firstDay is Monday for en-au/en-gb, Sunday
   for en-us. */
export const getFullCalendarLocale = () => {
    const locale = getFormattingLocale();

    if (typeof locale !== 'string') {
        return;
    }

    return locale.toLowerCase().replace('_', '-');
};
